"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import API from "@ym-framework/api-utils";
export class Changeteam {
  static change(team_id, type) {
    return __async(this, null, function* () {
      try {
        const responseToken = yield API.get(`api://base.local/storages/preference/token`);
        const _token = responseToken.data.value.token;
        let response = yield API.post(`api://base.login/v1/accounts/switchorg/${team_id}`, {}, {
          headers: {
            "X-AUTH-TOKEN": _token
          }
        });
        if (response.data.account_pin_verify && response.data.account_pin_verify !== null) {
          return {
            type: "pin",
            result: response.data.account_pin_verify
          };
        }
        if (response.data.account_device_permission && response.data.account_device_permission !== null) {
          return {
            type: "device",
            result: response.data.account_device_permission
          };
        }
        if (response.data.marks !== null && response.data.marks.tags.includes("TEAM_JOIN_ALERT")) {
          localStorage.setItem("showJoinTeamMessage", "true");
        }
        yield API.put(`api://base.local/storages/preference/token`, {
          token: response.data.token
        });
        return {
          type: "success",
          result: "success"
        };
      } catch (error) {
        let message = {
          type: "error",
          result: ""
        };
        console.log(error);
        if (error.hasOwnProperty("response")) {
          message.result = error.response.data.errors.datas[0].message;
        }
        return message;
      }
    });
  }
}
